import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Input, Select, Switch, InputNumber, notification, Button, Row, Col } from 'antd';

import _service from '@netuno/service-client';

import { FormattedMessage, useIntl } from 'react-intl';

import AddressFields from '../../../../../components/AddressFields';

const langContext = 'reserved-area.construction';

const layout = {
  labelCol: { span: 6, offset: 1 },
  wrapperCol: { span: 14 },
};

const validateMessages = {
  required: '${label} é obrigatório!',
  types: {
    email: '${label} is not a valid email!',
    number: '${label} is not a valid number!',
  },
  number: {
    range: '${label} must be between ${min} and ${max}',
  },
};

export default ({ uid }) => {
  let layoutButton = null;
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState([]);
  const [form] = Form.useForm();

  useEffect(() => {
    if (uid) {
      setLoading(true);
      _service({
        method: 'GET',
        url: 'construction',
        data: { uid },
        success: (response) => {
          setLoading(false);
          form.setFieldsValue({
            name: response.json.name,
            postal_code: response.json.postal_code,
            address_extra: response.json.address_extra,
            contact_available: response.json.contact_available
          });
          setData(response.json);
        },
        fail: (e) => {
          setLoading(false);
          notification["error"]({
            message: 'Erro no carregamento dos dados do Formulário',
            description: e.response.json.error,
          });
        }
      });
    }
  }, []);

  const intl = useIntl();
  const history = useHistory();

  function onFinish(values) {
    setSubmitting(true);
    console.log('values', values);

    const { name, address_extra, postal_code, contact_available } = values;
    if (uid) {
      _service({
        method: 'POST',
        url: '/construction',
        data: {
          uid,
          name,
          address_extra,
          postal_code,
          contact_available
        },
        success: (response) => {
          if (response.json.result) {
            notification["success"]({
              message: 'Obra guardada',
              description: 'Obra guardada com sucesso.',
            });
            setLoading(false);
            setSubmitting(false);
          } else {
            notification["warning"]({
              message: 'Obra não foi guardada com sucesso',
              description: response.json.error,
            });
            setSubmitting(false);
          }
        },
        fail: (e) => {
          notification["error"]({
            message: 'Erro na gravação da Obra',
            description: 'Não foi possível guardar a obra, contacte-nos através do chat de suporte.',
          });
        }
      });
    } else {
      _service({
        method: 'PUT',
        url: '/construction',
        data: {
          name,
          address_extra,
          postal_code,
          contact_available
        },
        success: (response) => {
          if (response.json.result) {
            notification["success"]({
              message: 'Obra Criada com sucesso',
            });
            setLoading(false);
            setSubmitting(false);
            history.push(`/construction/edit/${response.json.uid}`);
          } else {
            notification["warning"]({
              message: 'Obra não foi criada com sucesso',
              description: response.json.error,
            });
            setSubmitting(false);
          }
        },
        fail: (e) => {
          notification["error"]({
            message: 'Erro na Criação da Obra',
            description: 'Não foi possível criar a obra, contacte-nos através do chat de suporte.',
          });
        }
      });
    }
  };

  function onFinishFailed(errorInfo) {
    console.log('Failed:', errorInfo);
  }

  if (uid) {
    layoutButton =
      <Form.Item wrapperCol={{ md:{ offset: 12 }, lg:{ offset: 12, span: 14 } }}>
        <Button
          type="primary"
          htmlType="submit"
          loading={submitting}
        >
          <FormattedMessage id={`${langContext}.button.save`} />
        </Button>
      </Form.Item>
  } else {
    layoutButton =
      <Form.Item wrapperCol={{ md:{ offset: 12 }, lg:{ offset: 12, span: 14 } }}>
        <Button
          type="primary"
          htmlType="submit"
          loading={submitting}
        >
          <FormattedMessage id={`${langContext}.button.create`} />
        </Button>
      </Form.Item>
  }

  return (
    <Form
      name="construction"
      form={form}
      {...layout}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      validateMessages={validateMessages}
      labelCol={{ md:{ span: 14 }, lg:{span: 12} }}
      wrapperCol={{ span: 12 }}
    >
      <Form.Item
        label={intl.formatMessage({ id: langContext + '.fields.name' })}
        name={'name'}
        rules={[
          {
            required: true,
            message: 'Insira o nome da obra.'
          }
        ]}
      >
        <Input
          placeholder={intl.formatMessage({ id: langContext + '.fields.name' })}
          style={{ width: 'auto' }}
        />
      </Form.Item>
      <AddressFields form={form} />
      <Form.Item
        name={'contact_available'}
        label={intl.formatMessage({ id: langContext + '.fields.contact-available' })}
      >
        <Switch />
      </Form.Item>
      {layoutButton}
    </Form>
  );
}
